import { render, staticRenderFns } from "./CrashStatisticsItem.vue?vue&type=template&id=237a68ad&scoped=true&"
import script from "./CrashStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./CrashStatisticsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a68ad",
  null
  
)

export default component.exports